<template>
  <div class="hotels-wrapper">
    <QueueTabs
      :currentTab="currentTab"
      :counters="tabsCounters"
      @tabChanged="onTabSwitch"
      :tabs="{
        new: { important: true },
        processing: { important: false },
        done: { important: true },
      }"
    />

    <div class="orders-list">
      <div v-if="!isDesktop">
      <p class="text-center color-black my-4" v-if="!filteredList.length">
        {{ $t("queue.no_orders") }}
      </p>
      <div
        class="order-card-container"
        v-for="room_order in filteredList"
        :key="room_order._id"
      >
        <RoomOrderCard :room_order="room_order" class="mb-20" />
      </div>
    
    
      </div>
    </div>
    
      <div class="kanban-row" id="hotels-desktop-container" v-if="isDesktop">
        
        <div class="kanban-column">
          <p class="text-center color-black" v-if="!desktopListOrders.fresh.length">
          {{ $t("queue.no_orders") }}
        </p>   
          <div
            v-for="fresh in desktopListOrders.fresh"
            :key="fresh._id"
          >
            <RoomOrderCard :room_order="fresh" />
          </div>
        </div>
        <div class="kanban-column"> 
           <p class="text-center color-black" v-if="!desktopListOrders.processing.length">
          {{ $t("queue.no_orders") }}
        </p>
          <div v-for="processing in desktopListOrders.processing" :key="processing._id">
            <RoomOrderCard
              :room_order="processing"
            />
          </div>
        </div>
        <div class="kanban-column"> 
           <p class="text-center color-black" v-if="!desktopListOrders.done.length">
          {{ $t("queue.no_orders") }}
        </p>
          <div v-for="done in desktopListOrders.done" :key="done._id">
            <RoomOrderCard
              :room_order="done"
            />
          </div>
        </div>
       
      </div>
    
  </div>
</template>

<script>
import QueueTabs from "@/components/QueueTabs.vue";

import RoomOrderCard from "@/components/hotels/RoomOrderCard.vue";

export default {
  data() {
    return {
      currentTab: "new",

      fetch_interval_id: null,
    };
  },
  methods: {
    onTabSwitch(tab) {
      this.currentTab = tab;
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    tabsCounters() {
      return {
        new: this.allRoomOrders.filter((ro) => ro.status == "confirmed").length,
        processing: this.allRoomOrders.filter((ro) => ro.status == "serving")
          .length,
        done: this.allRoomOrders.filter((ro) => ro.status == "paying").length || this.allRoomOrders.filter((ro) => ro.status == "closed").length
       
      };
    },
    allRoomOrders() {
      return this.$store.state.hotels.room_orders;
    },
    filteredList() {
      return this.allRoomOrders.filter((ro) => {
        if (this.currentTab == "new") return ro.status == "confirmed";
        if (this.currentTab == "processing") return ro.status == "serving";
        if (this.currentTab == "done")
          return ro.status == "paying" || ro.status == "closed";
        return false;
      });
    },
    desktopListOrders() {
      return {
        fresh: this.allRoomOrders.filter((ro) => ro.status == "confirmed"),
        processing: this.allRoomOrders.filter((ro) => ro.status == "serving"),
        done: this.allRoomOrders.filter(
          (ro) => ro.status == "closed" || ro.status == "paying"
        ),
      };
    },
  },
  mounted() {
    this.$store.dispatch("hotels/fetchList");

    this.fetch_interval_id = setInterval(() => {
      this.$store.dispatch("hotels/fetchList");
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.fetch_interval_id);
  },
  components: {
    QueueTabs,
    RoomOrderCard,
  },
};
</script>

<style scoped>

p.text-center {
  margin:0;
}

.hotels-wrapper {
  padding: 0 0 15vh;
}

@media screen and (min-width: 768px) {
  .hotels-desktop-container {
    width: 100%;
    height: 100vh;
    display: flex;
  }
  
}
</style>